import { gql } from "@apollo/client";

export const DELETE_COMPANY_UPLOAD = gql`
  mutation DeleteCompanyUpload($companyId: String!, $filename: String!) {
    deleteCompanyUpload(companyId: $companyId, filename: $filename)
  }
`; 